import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/variables.css';
import './styles/utilities.css';
import './styles/common.css';
import './App.css';
import Header from './components/Header/Header';
import Breadcrumb from './components/Header/Breadcrumb';
import Footer from './components/Footer';
import FeedbackWidget from './components/FeedbackWidget';

import Main from './pages/Main';

import About from './pages/Introduction/About';
import Organization from './pages/Introduction/Organization';
import Map from './pages/Introduction/Map';
import History from './pages/Introduction/History';
import Campusmap from './pages/Introduction/Campusmap';
import CouncilDetail from './pages/Introduction/History/CouncilDetail';

import Announcement from './pages/News/Announcement/index';
import AnnouncementDetail from './pages/News/Announcement/AnnouncementDetail';

import Qna from './pages/Communication/Qna';
import QnaDetail from './pages/Communication/Qna/QnaDetail';
import Require from './pages/Communication/Require';
import RequireDetail from './pages/Communication/Require/RequireDetail';
import WritePage from './pages/Communication/WritePage';

import Bylaws from './pages/Resources/Bylaws';
import BylawsDetail from './pages/Resources/Bylaws/BylawsDetail';
import Proceeding from './pages/Resources/Proceeding';
import Audit from './pages/Resources/Audit';

import Promotion from './pages/Welfare/Promotion';
import Rental from './pages/Welfare/Rental';

import Profile from './pages/Auth/Profile';
import Admin from './pages/Admin';
import LinkHub from './pages/LinkHub';

import Sitemap from './pages/Utility/Sitemap';
import Termsofservice from './pages/Utility/Policy/termsofservice';
import Policy from './pages/Utility/Policy/policy';

import Intro from './pages/Acentia/intro';
import Goods from './pages/Acentia/goods';
import Record from './pages/Acentia/Record';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <div className="content">
            <Content />
          </div>
          <FeedbackWidget />
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

const Content = () => {
  const location = useLocation();
  const showBreadcrumb = location.pathname !== '/';

  // 메뉴 이동이 새로고침 없이 이뤄지므로 페이지가 바뀌면 맨 위로 올린다
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {showBreadcrumb && <Breadcrumb />}
      <Routes>
        <Route path="/" element={<Main />} />

        {/* Introduction */}
        <Route path="/introduction/about" element={<About />} />
        <Route path="/introduction/organization" element={<Organization />} />
        <Route path="/introduction/history" element={<History />} />
        <Route path="/introduction/history/:year" element={<CouncilDetail />} /> {/* ✅ 상세 라우트 */}
        <Route path="/introduction/map" element={<Map />} />
        <Route path="/introduction/campusmap" element={<Campusmap />} />

        {/* News */}
        <Route path="/news/notice" element={<Announcement />} />
        <Route path="/notice/:id" element={<AnnouncementDetail />} />

        {/* Communication */}
        <Route path="/communication/qna" element={<Qna />} />
        <Route path="/communication/qna/write" element={<WritePage />} />
        <Route path="/communication/qna/:postId" element={<QnaDetail />} />
        <Route path="/communication/require" element={<Require />} />
        <Route path="/communication/require/write" element={<WritePage />} />
        <Route path="/communication/require/:id" element={<RequireDetail />} />

        {/* Resources */}
        <Route path="/resources/bylaws" element={<Bylaws />} />
        <Route path="/resources/bylaws/:id" element={<BylawsDetail />} />
        <Route path="/resources/proceeding" element={<Proceeding />} />
        <Route path="/resources/audit" element={<Audit />} />

        {/* Welfare */}
        <Route path="/welfare/promotion" element={<Promotion />} />        
        <Route path="/welfare/rental" element={<Rental />} />

        {/* Acentia */}
        <Route path="/acentia/intro" element={<Intro />} />
        <Route path="/acentia/goods" element={<Goods />} />
        <Route path="/acentia/record" element={<Record />} />

        {/* Etc */}
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="ADMIN">
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route path="/linkHub" element={<LinkHub />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/policy/termsofservice" element={<Termsofservice />} />
        <Route path="/policy" element={<Policy />} />
      </Routes>
    </>
  );
};

export default App;
